// @ts-nocheck
import * as React from "react"
import * as TabsPrimitive from "@radix-ui/react-tabs"

import { cn } from "@/lib/utils"

/**
 * Design system Tabs (Radix wrapper).
 *
 * Two variants supported via `variant` prop on <TabsList> + <TabsTrigger> :
 *
 * - `pill` (default) — pill background gris muted avec un fond blanc + shadow
 *   sur l'onglet actif. Utilisé pour les toggles courts (ex: SMS / Email
 *   inside SMSPanel).
 *
 * - `underline` — sobre, border-bottom du conteneur + bordure colorée
 *   (`--vf-accent`) sur l'onglet actif. Utilisé pour les navigations
 *   primaires de page (Settings, AnalyticsScreen, SmsScreen page-level).
 *
 * Si tu veux ajouter une troisième variante, mets-la ici (DS-only) plutôt
 * que d'écrire des tabs custom dans la page consommatrice.
 */

const Tabs = TabsPrimitive.Root

const LIST_VARIANTS = {
  pill: "inline-flex h-9 items-center justify-center rounded-lg bg-muted p-1 text-muted-foreground",
  underline: "inline-flex items-center gap-1 border-b border-border w-full",
}

const TRIGGER_VARIANTS = {
  pill: "inline-flex items-center justify-center whitespace-nowrap rounded-md px-3 py-1 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow",
  underline:
    "inline-flex items-center gap-1.5 px-4 py-2.5 text-sm font-medium border-b-2 -mb-px whitespace-nowrap transition-colors " +
    "border-transparent text-[color:var(--vf-text-3)] hover:text-[color:var(--vf-text-1)] " +
    "data-[state=active]:border-[color:var(--vf-accent)] data-[state=active]:text-[color:var(--vf-accent)] " +
    "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 ring-offset-background " +
    "disabled:pointer-events-none disabled:opacity-50",
}

const TabsList = React.forwardRef(({ className, variant = "pill", ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    className={cn(LIST_VARIANTS[variant] ?? LIST_VARIANTS.pill, className)}
    {...props} />
))
TabsList.displayName = TabsPrimitive.List.displayName

const TabsTrigger = React.forwardRef(({ className, variant = "pill", ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(TRIGGER_VARIANTS[variant] ?? TRIGGER_VARIANTS.pill, className)}
    {...props} />
))
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName

const TabsContent = React.forwardRef(({ className, ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    className={cn(
      "mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
      className
    )}
    {...props} />
))
TabsContent.displayName = TabsPrimitive.Content.displayName

export { Tabs, TabsList, TabsTrigger, TabsContent }
